// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"0c4383b4","449":"1709ef3a"}[chunkId] + ".chunk.css";
};